import { createContext, useContext, useEffect, useState } from "react";
import ShoppingCart from "../Store/ShoppingCart";
import storeItems from "../data/StoreData.json";


const ShoppingContext = createContext({});

export const initialCartItems = localStorage.getItem("shopping-cart")
  ?
  JSON.parse(localStorage.getItem("shopping-cart")) : [];

export const initialWishList = localStorage.getItem("Wish-list")
  ?
  JSON.parse(localStorage.getItem("Wish-list")) : [];


  
const CartContext = ({children}) => {
const [isOpen, setisOpen] = useState(false);
const [CartItems, setCartItems] = useState(initialCartItems);
const [wishListItems, setwishListItems] = useState(initialWishList);
  
  useEffect(() => {
  localStorage.setItem("shopping-cart" , JSON.stringify(CartItems))
 } , [CartItems] )  
  
  useEffect(() => {
  localStorage.setItem("Wish-list" , JSON.stringify(wishListItems))
 } , [wishListItems] )    
  
  
  const cartQuantity = CartItems.reduce(
    (quantity, item) => item.quantity + quantity,
    0
  );
  
  const openCart = () => {
  setisOpen(true)
} 
  const closeCart = () => {
  setisOpen(false)
} 

  
const getWishListQuantity = (id) => {
return wishListItems.find((item) => item.id === id)?.quantity || 0;
};  
  
const addToWishList = (id) => {
    setwishListItems((currItems) => {
      if (currItems.find((item) => item.id === id) == null) {
        return [...currItems, { id, quantity: 1 }];
      } else {
        return currItems;
      }
    });
  };  
  
    const WishListQuantity = wishListItems.reduce(
    (quantity, item) => item.quantity + quantity,
    0
  );
const removeFromWishList = (id) => {
setwishListItems((currItems) => currItems.filter((item) => item.id !== id));
};
  
  
const getItemQuantity = (id) => {
return CartItems.find((item) => item.id === id)?.quantity || 0;
};
const increaseCartQuantity = (id) => {
    setCartItems((currItems) => {
      if (currItems.find((item) => item.id === id) == null) {
        return [...currItems, { id, quantity: 1 }];
      } else {
        return currItems.map((item) => {
          if (item.id === id) {
            return { ...item, quantity: item.quantity + 1 };
          } else {
            return item;
          }
        });
      }
    });
  };
const decreaseCartQuantity = (id) => {
    setCartItems((currItems) => {
      if (currItems.find((item) => item.id === id)?.quantity === 1) {
        return currItems.filter((item) => item.id !== id);
      } else {
        return currItems.map((item) => {
          if (item.id === id) {
            return { ...item, quantity: item.quantity - 1 };
          } else {
            return item;
          }
        });
      }
    });
  };
const removeFromCart = (id) => {
setCartItems((currItems) => currItems.filter((item) => item.id !== id));
};
    
  const gitIdproduct = (id) => {

    storeItems.find((i) => i.id === id);

} 
    
    
  return (
    <ShoppingContext.Provider
      value={{
        CartItems,
        cartQuantity,
        getItemQuantity,
        increaseCartQuantity,
        decreaseCartQuantity,
        removeFromCart,
        closeCart,
        openCart,
        gitIdproduct,
        getWishListQuantity,
        addToWishList,
        WishListQuantity,
        wishListItems,
        removeFromWishList
      }}>

      {children}
      <ShoppingCart isOpen={isOpen}/>
  </ShoppingContext.Provider>

  )
}

export default CartContext

export const useCartContext = () => {
   return useContext(ShoppingContext);
}




